import React from "react";

// Cloud Sync Icon
export const cloudSyncIcon = (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 13c1.1 0 2-.9 2-2 0-1.03-.79-1.87-1.8-1.98C15.45 6.58 13.24 5 10.5 5 8.39 5 6.5 6.17 5.6 8.01 3.65 8.06 2 9.73 2 12c0 2.21 1.79 4 4 4h10z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
        <path
            d="M10 11v6M13 14l-3-3-3 3"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
